"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require("babel-runtime/helpers/extends");

var _extends4 = _interopRequireDefault(_extends3);

exports.default = mapConstants;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapConstants(_ref) {
  var moduleName = _ref.moduleName,
      _ref$constants = _ref.constants,
      constants = _ref$constants === undefined ? [] : _ref$constants;

  return constants.reduce(function (result, constant) {
    return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, constant, moduleName + "/" + constant));
  }, {});
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/utils/map-constants.js
// module id = 876
// module chunks = 1